export const ASSESSMENT_TYPE_STANDARD = 'standard';
export const ASSESSMENT_TYPE_CUSTOM = 'custom';
